import { Button } from '@blueprintjs/core';
import styled from 'styled-components';

interface CenterContainerProps {
  fillAvailable?: boolean;
  constrainToParentWidth?: boolean;
}

export const CenterContainer = styled.div<CenterContainerProps>`
  margin: 0 auto;
  ${ ({ fillAvailable }) => fillAvailable ? 'flex: 1' : ''};
  ${ ({ constrainToParentWidth }) => constrainToParentWidth ? 'max-width: 100%' : ''};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
  margin: 0 40px;
  @media (max-width: 500px) {
    margin: 0 2px;
  }
`;

export const Header = styled.div`
  flex-direction: column;
  margin-top: 30px;
  margin-bottom: 40px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;
`;

export const ScalingButton = styled(Button)`
  @media (min-width: 360px) and (max-width: 500px) {
    height: 40px;
    min-width: 190px;
  }
`;



// WEBPACK FOOTER //
// ./src/screens/review-section3/styles.tsx